import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAcFilterReducer(state: RootState): ACFilterDataState {
  return state.acFilterReducer;
}
